var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaceDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_456_1134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_456_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3077 21C4.80257 21 4.375 20.825 4.025 20.475C3.675 20.125 3.5 19.6974 3.5 19.1923V5.8077C3.5 5.30257 3.675 4.875 4.025 4.525C4.375 4.175 4.80257 4 5.3077 4H18.6923C19.1974 4 19.625 4.175 19.975 4.525C20.325 4.875 20.5 5.30257 20.5 5.8077V19.1923C20.5 19.6974 20.325 20.125 19.975 20.475C19.625 20.825 19.1974 21 18.6923 21H5.3077ZM5.3077 19.5H11.25V5.49998H5.3077C5.23077 5.49998 5.16024 5.53203 5.09612 5.59613C5.03202 5.66024 4.99997 5.73077 4.99997 5.8077V19.1923C4.99997 19.2692 5.03202 19.3397 5.09612 19.4038C5.16024 19.4679 5.23077 19.5 5.3077 19.5ZM12.75 19.5H18.6923C18.7692 19.5 18.8397 19.4679 18.9038 19.4038C18.9679 19.3397 19 19.2692 19 19.1923V12.5H12.75V19.5ZM12.75 11H19V5.8077C19 5.73077 18.9679 5.66024 18.9038 5.59613C18.8397 5.53203 18.7692 5.49998 18.6923 5.49998H12.75V11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceDashboard);
export default __webpack_public_path__ + "static/media/space_dashboard.c448459372e829e78eab6501ef2346e8.svg";
export { ForwardRef as ReactComponent };